export const FUND_UNIVERSE_SINGLE = 'Fund Universe'
export const FUND_UNIVERSE_CSV = 'Fund Universe (CSV)'
export const FUND_UNIVERSE_FIDELITY = 'Fund Universe (Fidelity CSV)'
export const PLAN_LIST = 'Plan List'
export const RJ_PLAN_CONTACT = 'RJ Plan Contact'
